import { useEffect } from "react";

/**
 * Per-page <title> and meta description for the public pages. The app is a
 * client-rendered SPA, so this is what search engines that execute JS and
 * every browser tab see; index.html carries the landing-page defaults for
 * crawlers that don't.
 */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    const prevTitle = document.title;
    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.name = "description";
      document.head.appendChild(tag);
    }
    const prevDescription = tag.content;
    document.title = title;
    tag.content = description;
    return () => {
      document.title = prevTitle;
      if (tag) tag.content = prevDescription;
    };
  }, [title, description]);
}
